import React, { useContext } from 'react';
import { FlatList } from 'react-native';
import {
  Avatar,
  Card, Chip, Divider, IconButton, List,
  Text,
} from 'react-native-paper';
import { useMutation } from '@apollo/client';
import { AuthContext } from '../../../context/AuthContext';
import { EVENT_PARTICIPANT_MODE, ROLE_NAMES } from '../../../utils/constant';
import { ModalContext } from '../../../context/ModalContext';
import { computeCategorie } from '../../../utils/utils';
import { DeleteAchievement } from '../../../gql/achievement/mutation';
import { FindOneEvent } from '../../../gql/event/query';
import MedalFirstPlace from '../../../assets/medal-first-place-stroke-rounded.svg';
import MedalSecondPlace from '../../../assets/medal-second-place-stroke-rounded.svg';
import MedalThirdPlace from '../../../assets/medal-third-place-stroke-rounded.svg';
import { View } from 'native-base';

function EventResultsTab({ event, disabled = false }) {
  const { authState } = useContext(AuthContext);
  const { toggleCreateAchievementModal } = useContext(ModalContext);

  const [deleteAchievement] = useMutation(DeleteAchievement);

  const renderItem = ({ item: p }) => {
    if (p.achievements.length > 0) {
      return (
        <>
          <Divider />
          <List.Accordion
            title={`${p.player.firstName} ${p.player.lastName}`}
            expanded
            left={(props) => (p.player.profile.pictureThumbnail
              ? (
                <Avatar.Image
                  {...props}
                  source={{
                    uri: p.player.profile.pictureThumbnail,
                  }}
                />
              )
              : (
                <Avatar.Text
                  size={50}
                  label={`${p.player.firstName[0]}${p.player.lastName[0]}`}
                />
              ))}
            right={(props) => (
              authState.userId === p.player.id
              || authState.role === ROLE_NAMES.SUPERADMIN) && (
                <IconButton
                  {...props}
                  icon="plus"
                  onPress={() => toggleCreateAchievementModal({
                    eventId: Number(event.id),
                    userId: Number(p.player.id),
                    categories: event.level === 'INTERNATIONAL'
                      ? computeCategorie(
                        new Date(p.player.profile.dateOfBirth),
                        event.season,
                      ).international : computeCategorie(
                        new Date(p.player.profile.dateOfBirth),
                        event.season,
                      ).national,
                    gender: p.player.profile.gender,
                    weight: p.player.profile.weights[0].value,
                  })}
                />
              )}
          >
            {p.achievements.map((achievement) => (
              <List.Item

                key={achievement.id}
                left={(props) => (achievement.rank === 1
                  ? (
                    <IconButton
                      {...props}
                      iconColor="#edcb0f"
                      icon={MedalFirstPlace}
                    />
                  )
                  : achievement.rank === 2
                    ? (
                      <IconButton
                        {...props}
                        iconColor="#c0c0c0"
                        icon={MedalSecondPlace}
                      />
                    )
                    : achievement.rank === 3
                      ? (
                        <IconButton
                          {...props}
                          iconColor="#ce8946"
                          icon={MedalThirdPlace}
                        />
                      )
                      : (
                        <IconButton
                          {...props}
                          icon="numeric-5-circle"
                        />
                      ))}
                right={(props) => (
                  <View style={[props.style, { flexDirection: 'row', alignItems: 'center' }]}>
                    <Chip style={{ marginHorizontal: 1 }}>{achievement.category}</Chip>
                    <Chip style={{ marginHorizontal: 1 }}>
                      {achievement.weightCategory}
                      {' '}
                      kg
                    </Chip>
                    <Chip style={{ marginHorizontal: 1 }}>{Object.entries(EVENT_PARTICIPANT_MODE).find((item) => item[0] === achievement.mode)[1]}</Chip>
                    {(authState.userId === p.player.id || authState.role === ROLE_NAMES.SUPERADMIN)
                      && (
                        <IconButton

                          icon="delete"
                          onPress={() => {
                            deleteAchievement({
                              variables: {
                                id: achievement.id,
                              },
                              refetchQueries: [
                                FindOneEvent, // DocumentNode object parsed with gql
                                'findOneEvent', // Query name
                              ],
                            });
                          }}
                        />
                      )}
                  </View>
                )}
              />
            ))}
          </List.Accordion>
        </>
      );
    }

    return (
      <>
        <Divider />
        <List.Item
          title={`${p.player.firstName} ${p.player.lastName}`}
          left={(props) => (p.player.profile.pictureThumbnail
            ? (
              <Avatar.Image
                {...props}
                source={{
                  uri: p.player.profile.pictureThumbnail,
                }}
              />
            )
            : (
              <Avatar.Text
                size={50}
                label={`${p.player.firstName[0]}${p.player.lastName[0]}`}
              />
            ))}
          right={(props) => (
            (authState.userId === p.player.id
              || authState.role === ROLE_NAMES.SUPERADMIN) && (
              <IconButton
                {...props}
                icon="plus"
                onPress={() => toggleCreateAchievementModal({
                  eventId: Number(event.id),
                  userId: Number(p.player.id),
                  categories: event.level === 'INTERNATIONAL'
                    ? computeCategorie(
                      new Date(p.player.profile.dateOfBirth),
                      event.season,
                    ).international : computeCategorie(
                      new Date(p.player.profile.dateOfBirth),
                      event.season,
                    ).national,
                  gender: p.player.profile.gender,
                  weight: p.player.profile.weights[0].value,
                })}
              />
            )
          )}
        />
      </>
    );
  };

  if (disabled) {
    return (
      <Card.Content>
        <Text>
          {' '}
          La compétition n'est pas terminée, l'ajout de résultats ne sera possible que lorsque la compétition est terminée.
        </Text>
      </Card.Content>
    );
  }

  return (
    <Card.Content style={{ flex: 1 }}>
      <FlatList
        data={event?.players}
        renderItem={renderItem}
        keyExtractor={(item) => item.player.id.toString()}
      />
    </Card.Content>
  );
}

export default EventResultsTab;
